import * as React from 'react'
import Box from '@mui/material/Box'
import Collapse from '@mui/material/Collapse'
import IconButton from '@mui/material/IconButton'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Typography from '@mui/material/Typography'
import Paper from '@mui/material/Paper'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import TablePagination from '@mui/material/TablePagination'
import {
  Button,
  Grid,
  InputAdornment,
  MenuItem,
  TextField,
  useTheme,
} from '@mui/material'
import useCustomStyles from '../../../utils/hooks/CustomStylesHook'
import ToggleButton from '@mui/material/ToggleButton'
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup'
import SearchIcon from '@mui/icons-material/Search'
import dayjs from 'dayjs'
import {
  getHomeKareAppointments,
  updateHomeKareAppointment,
} from '../../../services/AdministrationService'
import { toast } from 'react-toastify'
import { homeKareStatus, KEY_TYPE_ENTER } from './Constants'

const styles = () => ({
  homekareContainer: {
    '& .MuiInputBase-input': {
      fontSize: '12px !important',
    },
    // '& .MuiInputLabel-root': {
    //   fontSize: '12px !important',
    // },
    // '& .MuiFormControlLabel-label': {
    //   fontSize: '12px !important',
    //   fontWeight: 600,
    // },
  },
  homekareTableContainer: {
    flex: 1,
    overflowY: 'auto',
  },
  homekareTableHeadRow: {
    '& td, & th': {
      backgroundColor: '#4682b4',
      color: '#ffffff',
    },
  },
  homekareTableRow: {
    '& > *': { borderBottom: 'unset' },
  },
  homekareTableCellCollapse: {
    paddingBottom: 0,
    paddingTop: 0,
  },
  homekareSubmitBtn: {
    textTransform: 'capitalize !important',
    fontSize: '12px',
    backgroundColor: '#183f7c',
  },
  homeKareToggleBtn: {
    textTransform: 'capitalize',
    '&.MuiToggleButton-root': {
      padding: '3px 5px',
    },
    '&.Mui-selected': {
      backgroundColor: '#183f7c',
      color: '#ffffff',
      '&:hover': {
        backgroundColor: '#183f7c',
        color: '#ffffff',
      },
    },
  },
  homeKareSearch: {
    width: '300px',
  },
})

function Row(props: any) {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)
  const { row, handleGetData } = props
  const [open, setOpen] = React.useState(false)
  const [status, setStatus] = React.useState(row?.statusOfCommunication)
  const [note, setNote] = React.useState(row?.comments)

  const handleSubmit = async () => {
    const response = await updateHomeKareAppointment(
      { statusOfCommunication: status, comments: note },
      row?.id
    )
    if (response?.success) {
      toast.success(response?.message)
      handleGetData()
    } else {
      toast.error(response?.message)
    }
  }

  return (
    <React.Fragment>
      <TableRow className={classes?.homekareTableRow} component={Paper}>
        <TableCell>
          <IconButton
            aria-label='expand row'
            size='small'
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component='th' scope='row'>
          {row?.muhId}
        </TableCell>
        <TableCell align='center'>{row?.patientName}</TableCell>
        <TableCell align='center'>{row?.phoneNumber}</TableCell>
        <TableCell align='center'>{row?.service}</TableCell>
        <TableCell align='center'>{row?.modeOfCommunication}</TableCell>
        <TableCell align='center'>{row?.statusOfCommunication}</TableCell>
        <TableCell align='center'>{row?.location}</TableCell>
        <TableCell align='center'>
          {row?.createdAt
            ? dayjs(row?.createdAt).format('MMMM D, YYYY h:mm A')
            : '-'}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes?.homekareTableCellCollapse} colSpan={9}>
          <Collapse in={open} timeout='auto' unmountOnExit>
            <Box m={1}>
              <Typography variant='h6' gutterBottom component='div'>
                Edit
              </Typography>
              <Grid container spacing={2}>
                <Grid item sm={12} xs={12} md={3} lg={3} xl={2}>
                  <TextField
                    select
                    name='status'
                    label='Status'
                    variant='outlined'
                    size='small'
                    fullWidth
                    onChange={(e) => setStatus(e?.target?.value)}
                    value={status}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled={status === homeKareStatus?.[3]?.value}
                  >
                    {homeKareStatus?.map((item: any, index: number) => {
                      return (
                        <MenuItem key={index} value={item?.value}>
                          {item?.label}
                        </MenuItem>
                      )
                    })}
                  </TextField>
                </Grid>
                <Grid item sm={12} xs={12} md={8} lg={8} xl={8}>
                  <TextField
                    multiline
                    name='Comments'
                    label='Comments'
                    variant='outlined'
                    size='small'
                    fullWidth
                    onChange={(e) => setNote(e.target.value)}
                    value={note}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
                <Grid item sm={12} xs={12} md={2} lg={1} xl={1}>
                  <Button
                    size='small'
                    variant='contained'
                    className={classes?.homekareSubmitBtn}
                    onClick={handleSubmit}
                  >
                    Submit
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  )
}

export default function HomeKare() {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)
  const [rows, setRows] = React.useState<any>([])
  const [page, setPage] = React.useState(0)
  const [rowsPerPage, setRowsPerPage] = React.useState(10)
  const [selectedStatus, setSelectedStatus] = React.useState(
    homeKareStatus?.[0]?.value
  )
  const [searchTerm, setSearchTerm] = React.useState('')
  const [searchText, setSearchText] = React.useState('')

  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    newStatus: string
  ) => {
    setSelectedStatus(newStatus)
  }

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const handleSearch = () => {
    setSearchTerm(searchText)
  }

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === KEY_TYPE_ENTER) {
      setSearchTerm(searchText)
    }
  }

  const handleGetData = React.useCallback(async () => {
    const response = await getHomeKareAppointments(
      page,
      rowsPerPage,
      searchTerm,
      selectedStatus
    )
    if (response?.success) {
      setRows(response?.data?.data)
      // toast.success(response?.message)
    } else {
      setRows([])
      toast.error(response?.message)
    }
  }, [page, rowsPerPage, selectedStatus, searchTerm])

  React.useEffect(() => {
    handleGetData()
  }, [handleGetData])

  return (
    <Box
      className={classes?.homekareContainer}
      paddingTop={2}
      pl={4}
      pr={4}
      width='100%'
      height='93vh'
      display='flex'
      flexDirection='column'
      justifyContent={'center'}
      overflow='hidden'
    >
      <Box
        display={'flex'}
        justifyContent={'space-between'}
        alignItems={'center'}
        flexWrap={'wrap'}
        mb={2}
      >
        <Typography variant='h6'>HomeKare</Typography>
        <Box display={'flex'} flexDirection={'row'} gap={3} pr={2}>
          <Box>
            <ToggleButtonGroup
              className={classes?.homeKareToggleBtn}
              size='small'
              color='primary'
              value={selectedStatus}
              exclusive
              onChange={handleChange}
              aria-label='Platform-status'
            >
              {homeKareStatus?.map((item: any, index: number) => {
                return (
                  <ToggleButton
                    className={classes?.homeKareToggleBtn}
                    value={item?.value}
                    key={index}
                  >
                    {item?.label}
                  </ToggleButton>
                )
              })}
            </ToggleButtonGroup>
          </Box>
          <TextField
            placeholder='Search'
            type='text'
            size='small'
            value={searchText}
            onChange={(e) => setSearchText(e?.target?.value)}
            onKeyDown={handleKeyDown}
            className={classes?.homeKareSearch}
            InputProps={{
              endAdornment: (
                <InputAdornment position='end'>
                  <IconButton size='small' onClick={handleSearch}>
                    <SearchIcon htmlColor='#183f7c' fontSize='small' />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Box>
      </Box>
      <TableContainer className={classes?.homekareTableContainer}>
        <Table stickyHeader size='small' aria-label='collapsible table'>
          <TableHead>
            <TableRow className={classes?.homekareTableHeadRow}>
              <TableCell />
              <TableCell>UHID</TableCell>
              <TableCell align='center'>Name</TableCell>
              <TableCell align='center'>Phone Number</TableCell>
              <TableCell align='center'>Service</TableCell>
              <TableCell align='center'>Mode of Communication</TableCell>
              <TableCell align='center'>Status</TableCell>
              <TableCell align='center'>Location</TableCell>
              <TableCell align='center'>Communication Date/time</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows?.map((row: any) => (
              <Row key={row?.id} row={row} handleGetData={handleGetData} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Box display={'flex'} justifyContent={'start'}>
        <TablePagination
          component='div'
          count={rows.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Box>
    </Box>
  )
}
